import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column kn-flex kn-height-full" }
const _hoisted_2 = {
  id: "left-and-table-container",
  class: "p-d-flex p-flex-row kn-flex"
}
const _hoisted_3 = { class: "p-d-flex p-flex-column" }
const _hoisted_4 = { class: "p-text-center p-d-flex p-flex-row p-ai-center" }
const _hoisted_5 = { class: "p-ml-2" }
const _hoisted_6 = {
  id: "whatif-input",
  ref: "whatifInput",
  class: "p-inputgroup"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_OlapCustomViewTable = _resolveComponent("OlapCustomViewTable")
  const _component_DrillTruDialog = _resolveComponent("DrillTruDialog")
  const _component_FilterPanel = _resolveComponent("FilterPanel")
  const _component_FilterTopToolbar = _resolveComponent("FilterTopToolbar")
  const _component_FilterLeftToolbar = _resolveComponent("FilterLeftToolbar")
  const _component_Button = _resolveComponent("Button")
  const _component_OlapSidebar = _resolveComponent("OlapSidebar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_OlapCustomViewSaveDialog = _resolveComponent("OlapCustomViewSaveDialog")
  const _component_OlapSortingDialog = _resolveComponent("OlapSortingDialog")
  const _component_OlapMDXQueryDialog = _resolveComponent("OlapMDXQueryDialog")
  const _component_OlapCrossNavigationDefinitionDialog = _resolveComponent("OlapCrossNavigationDefinitionDialog")
  const _component_OlapButtonWizardDialog = _resolveComponent("OlapButtonWizardDialog")
  const _component_MultiHierarchyDialog = _resolveComponent("MultiHierarchyDialog")
  const _component_KnOverlaySpinnerPanel = _resolveComponent("KnOverlaySpinnerPanel")
  const _component_OutputWizard = _resolveComponent("OutputWizard")
  const _component_ScenarioWizard = _resolveComponent("ScenarioWizard")
  const _component_AlgorithmDialog = _resolveComponent("AlgorithmDialog")
  const _component_OlapFilterDialog = _resolveComponent("OlapFilterDialog")
  const _component_OlapSaveNewVersionDialog = _resolveComponent("OlapSaveNewVersionDialog")
  const _component_OlapDeleteVersionsDialog = _resolveComponent("OlapDeleteVersionsDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
            key: 0,
            class: "kn-progress-spinner"
          }))
        : _createCommentVNode("", true),
      (_ctx.customViewVisible)
        ? (_openBlock(), _createBlock(_component_OlapCustomViewTable, {
            key: 1,
            class: "olap-overlay-dialog",
            olapCustomViews: _ctx.olapCustomViews,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeOlapCustomView'))),
            onApplyCustomView: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('applyCustomView', $event)))
          }, null, 8, ["olapCustomViews"]))
        : _createCommentVNode("", true),
      (_ctx.drillTruDialogVisible)
        ? (_openBlock(), _createBlock(_component_DrillTruDialog, {
            key: 2,
            drillData: _ctx.dtData,
            tableColumns: _ctx.formattedColumns,
            dtLevels: _ctx.dtAssociatedLevels,
            menuTree: _ctx.dtTree,
            dtMaxRows: _ctx.dtMaxRows,
            class: "olap-overlay-dialog",
            onClose: _ctx.closeDrillTruDialog,
            onCheckCheckboxes: _ctx.checkCheckboxes,
            onClearLevels: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dtAssociatedLevels.length = 0)),
            onRowsChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dtMaxRows = $event)),
            onDrill: _ctx.drillThrough
          }, null, 8, ["drillData", "tableColumns", "dtLevels", "menuTree", "dtMaxRows", "onClose", "onCheckCheckboxes", "onDrill"]))
        : _createCommentVNode("", true),
      _createVNode(_component_FilterPanel, {
        olapProp: _ctx.olap,
        olapDesigner: _ctx.olapDesigner,
        onPutFilterOnAxis: _ctx.putFilterOnAxis,
        onShowMultiHierarchy: _ctx.showMultiHierarchy,
        onOpenFilterDialog: _ctx.openFilterDialog
      }, null, 8, ["olapProp", "olapDesigner", "onPutFilterOnAxis", "onShowMultiHierarchy", "onOpenFilterDialog"]),
      _createVNode(_component_FilterTopToolbar, {
        olapProp: _ctx.olap,
        onOpenSidebar: _cache[5] || (_cache[5] = ($event: any) => (_ctx.olapSidebarVisible = true)),
        onPutFilterOnAxis: _ctx.putFilterOnAxis,
        onSwapAxis: _ctx.swapAxis,
        onSwitchPosition: _ctx.moveHierarchies,
        onShowMultiHierarchy: _ctx.showMultiHierarchy,
        onOpenFilterDialog: _ctx.openFilterDialog
      }, null, 8, ["olapProp", "onPutFilterOnAxis", "onSwapAxis", "onSwitchPosition", "onShowMultiHierarchy", "onOpenFilterDialog"]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_FilterLeftToolbar, {
          olapProp: _ctx.olap,
          onOpenSidebar: _cache[6] || (_cache[6] = ($event: any) => (_ctx.olapSidebarVisible = true)),
          onPutFilterOnAxis: _ctx.putFilterOnAxis,
          onSwitchPosition: _ctx.moveHierarchies,
          onShowMultiHierarchy: _ctx.showMultiHierarchy,
          onOpenFilterDialog: _ctx.openFilterDialog
        }, null, 8, ["olapProp", "onPutFilterOnAxis", "onSwitchPosition", "onShowMultiHierarchy", "onOpenFilterDialog"]),
        _createVNode("div", {
          id: "table-container",
          class: "kn-flex",
          style: _ctx.olapDescriptor.style.tableContainer
        }, [
          _createVNode("div", {
            id: "olap-table",
            class: "kn-flex kn-olap-table",
            ref: "olap-table",
            innerHTML: _ctx.olap.table,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleTableClick && _ctx.handleTableClick(...args))),
            onDblclick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleTableDoubleClick && _ctx.handleTableDoubleClick(...args)))
          }, null, 40, ["innerHTML"])
        ], 4)
      ]),
      (_ctx.mode === 'From Cell' || _ctx.mode === 'From Member')
        ? (_openBlock(), _createBlock("div", {
            key: 3,
            id: "custom-toast",
            style: _ctx.olapDescriptor.style.customToastContainer
          }, [
            _createVNode("div", {
              id: "custom-toast-content",
              style: _ctx.olapDescriptor.style.customToastContent
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("i", {
                    class: "pi pi-info-circle p-ml-2",
                    style: _ctx.olapDescriptor.style.toastIcon
                  }, null, 4),
                  _createVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('documentExecution.olap.crossNavigationDefinition.finishSelection')), 1),
                  _createVNode(_component_Button, {
                    class: "p-jc-center",
                    style: _ctx.olapDescriptor.style.toastButton,
                    label: "OK",
                    onClick: _ctx.cellSelected
                  }, null, 8, ["style", "onClick"])
                ])
              ])
            ], 4)
          ], 4))
        : _createCommentVNode("", true),
      (_ctx.olapSidebarVisible)
        ? (_openBlock(), _createBlock("div", {
            key: 4,
            id: "olap-backdrop",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.olapSidebarVisible = false))
          }))
        : _createCommentVNode("", true),
      (_ctx.olapSidebarVisible)
        ? (_openBlock(), _createBlock(_component_OlapSidebar, {
            key: 5,
            class: "olap-sidebar kn-overflow-y",
            olap: _ctx.olap,
            olapDesignerMode: _ctx.olapDesignerMode,
            propButtons: _ctx.buttons,
            whatIfMode: _ctx.whatIfMode,
            olapHasScenario: _ctx.olapHasScenario,
            onOpenCustomViewDialog: _cache[10] || (_cache[10] = ($event: any) => (_ctx.customViewSaveDialogVisible = true)),
            onDrillTypeChanged: _ctx.onDrillTypeChanged,
            onShowParentMemberChanged: _ctx.onShowParentMemberChanged,
            onHideSpansChanged: _ctx.onHideSpansChanged,
            onSuppressEmptyChanged: _ctx.onSuppressEmptyChanged,
            onDrillThroughChanged: _ctx.onDrillThroughChanged,
            onShowPropertiesChanged: _ctx.onShowPropertiesChanged,
            onOpenSortingDialog: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortingDialogVisible = true)),
            onOpenMdxQueryDialog: _cache[12] || (_cache[12] = ($event: any) => (_ctx.mdxQueryDialogVisible = true)),
            onReloadSchema: _ctx.reloadOlap,
            onEnableCrossNavigation: _ctx.enableCrossNaivigation,
            onOpenCrossNavigationDefinitionDialog: _cache[13] || (_cache[13] = ($event: any) => (_ctx.crossNavigationDefinitionDialogVisible = true)),
            onOpenButtonWizardDialog: _cache[14] || (_cache[14] = ($event: any) => (_ctx.buttonsWizardDialogVisible = true)),
            onSaveOlapDesigner: _ctx.saveOlapDesigner,
            onShowOutputWizard: _cache[15] || (_cache[15] = ($event: any) => (_ctx.outputWizardVisible = true)),
            onShowScenarioWizard: _cache[16] || (_cache[16] = ($event: any) => (_ctx.scenarioWizardVisible = true)),
            onShowSaveAsNewVersion: _cache[17] || (_cache[17] = ($event: any) => (_ctx.saveVersionDialogVisible = true)),
            onShowAlgorithmDialog: _cache[18] || (_cache[18] = ($event: any) => (_ctx.algorithmDialogVisible = true)),
            onUndo: _ctx.undo,
            onShowDeleteVersions: _cache[19] || (_cache[19] = ($event: any) => (_ctx.deleteVersionDialogVisible = true)),
            onExportExcel: _ctx.exportExcel,
            onLoading: _cache[20] || (_cache[20] = ($event: any) => (_ctx.loading = $event))
          }, null, 8, ["olap", "olapDesignerMode", "propButtons", "whatIfMode", "olapHasScenario", "onDrillTypeChanged", "onShowParentMemberChanged", "onHideSpansChanged", "onSuppressEmptyChanged", "onDrillThroughChanged", "onShowPropertiesChanged", "onReloadSchema", "onEnableCrossNavigation", "onSaveOlapDesigner", "onUndo", "onExportExcel"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_InputText, {
        modelValue: _ctx.whatifInputNewValue,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.whatifInputNewValue = $event)),
        onKeyup: _withKeys(_ctx.onWhatifInput, ["enter"])
      }, null, 8, ["modelValue", "onKeyup"]),
      _createVNode(_component_InputText, {
        modelValue: _ctx.whatifInputOldValue,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.whatifInputOldValue = $event)),
        disabled: true
      }, null, 8, ["modelValue"]),
      _createVNode(_component_Button, {
        icon: "pi pi-times",
        class: "kn-button--secondary",
        onClick: _ctx.closeWhatifInput
      }, null, 8, ["onClick"])
    ], 512),
    _createVNode(_component_OlapCustomViewSaveDialog, {
      visible: _ctx.customViewSaveDialogVisible,
      sbiExecutionId: _ctx.id,
      onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.customViewSaveDialogVisible = false))
    }, null, 8, ["visible", "sbiExecutionId"]),
    _createVNode(_component_OlapSortingDialog, {
      visible: _ctx.sortingDialogVisible,
      olap: _ctx.olap,
      onSave: _ctx.onSortingSelect
    }, null, 8, ["visible", "olap", "onSave"]),
    _createVNode(_component_OlapMDXQueryDialog, {
      visible: _ctx.mdxQueryDialogVisible,
      mdxQuery: _ctx.olap?.MDXWITHOUTCF,
      onClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.mdxQueryDialogVisible = false))
    }, null, 8, ["visible", "mdxQuery"]),
    _createVNode(_component_OlapCrossNavigationDefinitionDialog, {
      visible: _ctx.crossNavigationDefinitionDialogVisible,
      propOlapDesigner: _ctx.olapDesigner,
      selectedCell: _ctx.selectedCell,
      onClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.crossNavigationDefinitionDialogVisible = false)),
      onSelectFromTable: _cache[26] || (_cache[26] = ($event: any) => (_ctx.enterSelectMode($event)))
    }, null, 8, ["visible", "propOlapDesigner", "selectedCell"]),
    _createVNode(_component_OlapButtonWizardDialog, {
      visible: _ctx.buttonsWizardDialogVisible,
      propButtons: _ctx.buttons,
      propOlapDesigner: _ctx.olapDesigner,
      onClose: _cache[27] || (_cache[27] = ($event: any) => (_ctx.buttonsWizardDialogVisible = false))
    }, null, 8, ["visible", "propButtons", "propOlapDesigner"]),
    _createVNode(_component_MultiHierarchyDialog, {
      selectedFilter: _ctx.multiHierFilter,
      multiHierUN: _ctx.selecetedMultiHierUN,
      visible: _ctx.multiHierarchyDialogVisible,
      onSetMultiHierUN: _ctx.setMultiHierUN,
      onUpdateHierarchy: _ctx.updateHierarchy,
      onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.multiHierarchyDialogVisible = false))
    }, null, 8, ["selectedFilter", "multiHierUN", "visible", "onSetMultiHierUN", "onUpdateHierarchy"]),
    _createVNode(_component_KnOverlaySpinnerPanel, { visibility: _ctx.loading }, null, 8, ["visibility"]),
    (_ctx.outputWizardVisible)
      ? (_openBlock(), _createBlock(_component_OutputWizard, {
          key: 0,
          visible: _ctx.outputWizardVisible,
          olapVersionsProp: _ctx.olapVersions,
          sbiExecutionId: _ctx.id,
          onClose: _cache[29] || (_cache[29] = ($event: any) => (_ctx.outputWizardVisible = false))
        }, null, 8, ["visible", "olapVersionsProp", "sbiExecutionId"]))
      : _createCommentVNode("", true),
    (_ctx.scenarioWizardVisible)
      ? (_openBlock(), _createBlock(_component_ScenarioWizard, {
          key: 1,
          visible: _ctx.scenarioWizardVisible,
          artifactIdProp: _ctx.artifactId,
          sbiExecutionId: _ctx.id,
          olapDesignerProp: _ctx.olapDesigner,
          onSaveScenario: _ctx.saveScenario,
          onDeleteScenario: _ctx.deleteScenario,
          onClose: _cache[30] || (_cache[30] = ($event: any) => (_ctx.scenarioWizardVisible = false))
        }, null, 8, ["visible", "artifactIdProp", "sbiExecutionId", "olapDesignerProp", "onSaveScenario", "onDeleteScenario"]))
      : _createCommentVNode("", true),
    (_ctx.algorithmDialogVisible)
      ? (_openBlock(), _createBlock(_component_AlgorithmDialog, {
          key: 2,
          visible: _ctx.algorithmDialogVisible,
          sbiExecutionId: _ctx.id,
          onClose: _cache[31] || (_cache[31] = ($event: any) => (_ctx.algorithmDialogVisible = false))
        }, null, 8, ["visible", "sbiExecutionId"]))
      : _createCommentVNode("", true),
    _createVNode(_component_OlapFilterDialog, {
      visible: _ctx.filterDialogVisible,
      propFilter: _ctx.selectedFilter,
      id: _ctx.id,
      olapDesignerMode: _ctx.olapDesignerMode,
      parameters: _ctx.parameters,
      profileAttributes: _ctx.profileAttributes,
      olapDesigner: _ctx.olapDesigner,
      onClose: _ctx.closeFilterDialog,
      onApplyFilters: _ctx.applyFilters
    }, null, 8, ["visible", "propFilter", "id", "olapDesignerMode", "parameters", "profileAttributes", "olapDesigner", "onClose", "onApplyFilters"]),
    _createVNode(_component_OlapSaveNewVersionDialog, {
      visible: _ctx.saveVersionDialogVisible,
      id: _ctx.id,
      onClose: _cache[32] || (_cache[32] = ($event: any) => (_ctx.saveVersionDialogVisible = false)),
      onNewVersionSaved: _ctx.onNewVersionSaved
    }, null, 8, ["visible", "id", "onNewVersionSaved"]),
    _createVNode(_component_OlapDeleteVersionsDialog, {
      visible: _ctx.deleteVersionDialogVisible,
      id: _ctx.id,
      propOlapVersions: _ctx.olapVersions,
      olap: _ctx.olap,
      onClose: _cache[33] || (_cache[33] = ($event: any) => (_ctx.deleteVersionDialogVisible = false))
    }, null, 8, ["visible", "id", "propOlapVersions", "olap"])
  ], 64))
}